<div class="toast">
  <div class="toast__content toast__content--{{ TOASTS[toastType()].color }}">
    <div class="toast__content-header">
      <div class="toast__line toast__line--{{ TOASTS[toastType()].color }}"></div>
      <div class="toast__content-text">
        <div class="toast__header">
          <h3 class="toast__header-title toast__header-title--{{ TOASTS[toastType()].color }}">
            {{ TOASTS[toastType()].title }}
          </h3>
          <mdcr-button
            class="icon"
            (click)="onCancel()"
            aria-label="Close"
            [iconPath]="SVG.closeGrey"
            [iconAlt]="'Close'"
          />
        </div>

        <p class="toast__text toast__text--{{ TOASTS[toastType()].color }}">
          {{ TOASTS[toastType()].text }}
        </p>
      </div>
    </div>
    @if (TOASTS[toastType()].confirmText || TOASTS[toastType()].cancelText) {
      <div class="toast__actions">
        <mdcr-button
          class="outlined-muted large"
          [label]="TOASTS[toastType()].cancelText"
          (click)="onCancel()"
        />
        <mdcr-button
          class="success large"
          [label]="TOASTS[toastType()].confirmText"
          (click)="onConfirm()"
        />
      </div>
    }
  </div>
</div>
